import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { i18n } from '../../i18n';
import { useIsSmallScreen } from '../../hooks';

export const sendSignUpSuccessModal: any = {};

export const SendSignUpSuccessModal = () => {
  const isSmallScreen = useIsSmallScreen();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    sendSignUpSuccessModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    setOpen(!open);
  };

  return (
    <ModalBase
      id={'send-contract-modal'}
      paperSize={isSmallScreen ? 'mobile' : 'default'}
      open={open}
      onClose={handleOnClose}
    >
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {isSmallScreen
            ? i18n.t('pages.modal.sendSignUpSuccessShortTitle')
            : i18n.t('pages.modal.sendSignUpSuccessTitle')}
        </Typography>
        <Typography variant={'textM'} breakSpaces>
          {i18n.t('pages.modal.sendSignUpSuccessBody')}
        </Typography>
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'primary'} onClick={handleOnClose}>
            {i18n.t('button.ok')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
